import {cn} from 'platform/shared-tw';

import {
  createKeyDownHandler,
  partFill,
  partStroke,
  type DiagramVariant,
} from '../shared/partVariants';

interface RightUpperSuspensionCoverProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RightUpperSuspensionCover(props: RightUpperSuspensionCoverProps) {
  return (
    <svg
      width="119"
      height="159"
      viewBox="0 0 119 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute focus:outline-none focus-visible:outline-none ${props.onClick ? 'cursor-pointer group' : ''}`}
      style={{top: 26, left: 258}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
      aria-label={props.onClick ? 'Right Upper Suspension Cover' : undefined}
    >
      <path
        d="M2.00337 50.9597L2.00336 2.99839L2 2.882L86 1.00012C92.7571 1.00004 105.724 2.36873 117.866 8.18873L118 7.99436C117.962 8.06094 117.923 8.12787 117.885 8.19514C102.882 34.3777 80 112.974 80 137.89C80 147.76 75.1212 151.78 70.1829 155.849L70 156V155.875C70 127.898 70 110.911 26 87.93C2.16665 75.6779 2.00337 55.9557 2.00337 50.9597Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M55.0888 19C62.3856 19.0001 69.0334 21.7669 74.0303 26.3042C75.0853 25.419 76.4484 24.8854 77.9363 24.8854C81.285 24.8855 83.9999 27.5877 84 30.9208C84 33.1387 82.7968 35.0756 81.0058 36.1246C82.4194 39.4633 83.2022 43.1318 83.2022 46.9823C83.2022 60.3769 73.7455 71.5698 61.1159 74.3163C61.1388 74.5293 61.1525 74.7455 61.1525 74.9646C61.1525 78.2977 58.4374 80.9997 55.0888 81C51.7399 81 49.0252 78.2979 49.0252 74.9646C49.0252 74.7456 49.0367 74.5293 49.0596 74.3163C36.4305 71.5694 26.9754 60.3765 26.9754 46.9823C26.9754 43.1631 27.7444 39.5229 29.1363 36.206C27.267 35.1779 26 33.1969 26 30.9208C26.0001 27.5876 28.716 24.8854 32.0647 24.8854C33.5957 24.8855 34.9931 25.4518 36.0602 26.3835C41.0668 21.7993 47.7496 19 55.0888 19Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M117.881 8.20129L118 7.99436M118 7.99436C103 33.9734 80 112.91 80 137.89C80 147.882 75 151.878 70 156V155.875C70 127.898 70 110.911 26 87.93C2.16665 75.6779 2.00337 55.9557 2.00337 50.9597L2.00336 2.99839L2 2.882C27.3758 2.3135 54.1251 1.71423 86 1.00012C92.7571 1.00004 105.724 2.36873 117.866 8.18873L118 7.99436Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="55"
        cy="47"
        r="22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="55"
        cy="47"
        r="10"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="55"
        cy="47"
        r="3"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="78"
        cy="31"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="32"
        cy="31"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="55"
        cy="75"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M55.0888 19C62.3856 19.0001 69.0334 21.7669 74.0303 26.3042C75.0853 25.419 76.4484 24.8854 77.9363 24.8854C81.285 24.8855 83.9999 27.5877 84 30.9208C84 33.1387 82.7968 35.0756 81.0058 36.1246C82.4194 39.4633 83.2022 43.1318 83.2022 46.9823C83.2022 60.3769 73.7455 71.5698 61.1159 74.3163C61.1388 74.5293 61.1525 74.7455 61.1525 74.9646C61.1525 78.2977 58.4374 80.9997 55.0888 81C51.7399 81 49.0252 78.2979 49.0252 74.9646C49.0252 74.7456 49.0367 74.5293 49.0596 74.3163C36.4305 71.5694 26.9754 60.3765 26.9754 46.9823C26.9754 43.1631 27.7444 39.5229 29.1363 36.206C27.267 35.1779 26 33.1969 26 30.9208C26.0001 27.5876 28.716 24.8854 32.0647 24.8854C33.5957 24.8855 34.9931 25.4518 36.0602 26.3835C41.0668 21.7993 47.7496 19 55.0888 19Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
